import { render, staticRenderFns } from "./drag.vue?vue&type=template&id=244c54c7&"
import script from "./drag.vue?vue&type=script&lang=js&"
export * from "./drag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../wx-ktv-build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports